import request from './request';

export interface LoginParams {
  username: string;
  pwd: string;
  verificationCode: string;
}

export interface LoginResponse {
  code: number;
  message: string;
  data: string; // JWT Token
}

/**
 * 用户登录
 * @param params 登录参数
 */
export const login = (params: LoginParams): Promise<string> => {
  return request.post('/admin/admin/api/auth/login', params);
}; 